import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Trophy, User, LogOut, Shield, BarChart3 } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const ADMIN_EMAIL = 't.m@mimc.online';

export const DashboardSidebar = ({ user, onLogout }) => {
  const { t } = useLanguage();

  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-card border-r border-border hidden lg:block">
      <div className="p-6">
        <div className="flex items-center gap-2 mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_egns-deutsch/artifacts/wljgvqe2_copy_DF94F79F-AD21-40BD-8A6F-78D3B8D2676A.jpeg"
            alt="EGNS Logo"
            className="h-10 w-auto"
          />
        </div>

        <nav className="space-y-2">
          <Link to="/dashboard" className="flex items-center gap-3 px-4 py-3 rounded-lg bg-primary/10 text-primary font-medium" data-testid="nav-dashboard">
            <LayoutDashboard className="h-5 w-5" /> {t('dashboard')}
          </Link>
          <Link to="/lessons" className="flex items-center gap-3 px-4 py-3 rounded-lg text-muted-foreground hover:bg-muted transition-colors" data-testid="nav-lessons">
            <BookOpen className="h-5 w-5" /> {t('lessons')}
          </Link>
          <Link to="/achievements" className="flex items-center gap-3 px-4 py-3 rounded-lg text-muted-foreground hover:bg-muted transition-colors" data-testid="nav-achievements">
            <Trophy className="h-5 w-5" /> {t('achievements')}
          </Link>
          <Link to="/my-progress" className="flex items-center gap-3 px-4 py-3 rounded-lg text-muted-foreground hover:bg-muted transition-colors" data-testid="nav-my-progress">
            <BarChart3 className="h-5 w-5" /> My Progress
          </Link>
          <Link to="/profile" className="flex items-center gap-3 px-4 py-3 rounded-lg text-muted-foreground hover:bg-muted transition-colors" data-testid="nav-profile">
            <User className="h-5 w-5" /> {t('profile')}
          </Link>
          {user?.email === ADMIN_EMAIL && (
            <Link to="/admin" className="flex items-center gap-3 px-4 py-3 rounded-lg text-amber-500 hover:bg-amber-500/10 transition-colors" data-testid="nav-admin">
              <Shield className="h-5 w-5" /> Admin Panel
            </Link>
          )}
        </nav>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-border">
        <button onClick={onLogout} className="flex items-center gap-3 px-4 py-3 w-full rounded-lg text-muted-foreground hover:bg-destructive/10 hover:text-destructive transition-colors" data-testid="logout-btn">
          <LogOut className="h-5 w-5" /> {t('logout')}
        </button>
      </div>
    </aside>
  );
};

export const MobileBottomNav = () => {
  const { t } = useLanguage();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border lg:hidden">
      <div className="grid grid-cols-4 gap-1 p-2">
        <Link to="/dashboard" className="flex flex-col items-center gap-1 py-2 text-primary">
          <LayoutDashboard className="h-5 w-5" /><span className="text-xs">{t('dashboard')}</span>
        </Link>
        <Link to="/lessons" className="flex flex-col items-center gap-1 py-2 text-muted-foreground">
          <BookOpen className="h-5 w-5" /><span className="text-xs">{t('lessons')}</span>
        </Link>
        <Link to="/achievements" className="flex flex-col items-center gap-1 py-2 text-muted-foreground">
          <Trophy className="h-5 w-5" /><span className="text-xs">{t('achievements')}</span>
        </Link>
        <Link to="/profile" className="flex flex-col items-center gap-1 py-2 text-muted-foreground">
          <User className="h-5 w-5" /><span className="text-xs">{t('profile')}</span>
        </Link>
      </div>
    </nav>
  );
};
